import { render, staticRenderFns } from "./couponItemDetail.vue?vue&type=template&id=3101b4ec&scoped=true&"
import script from "./couponItemDetail.vue?vue&type=script&lang=js&"
export * from "./couponItemDetail.vue?vue&type=script&lang=js&"
import style0 from "./couponItemDetail.vue?vue&type=style&index=0&id=3101b4ec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3101b4ec",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
